<template>
	<v-card>
		<v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
		<v-card-text class="pt-0">
			<v-data-table :headers="data.headers" :items="data.list" :loading="query.loading" class="elevation-1"
				disable-pagination hide-default-footer item-key="id" loading-text="正在加载,请稍候......">
				<template v-slot:top>
					<v-row dense class="mb-n5">
						<v-col cols="12" class="d-flex flex-wrap mt-2 ml-2">
							<div style="width: 260px;" class="mr-1">
								<v-menu ref="menu1" v-model="menu1" :close-on-content-click="false"
								    transition="scale-transition" offset-y
									min-width="auto">
									<template v-slot:activator="{ on, attrs }">
										<v-text-field v-model="query.start" label="开始日期" readonly v-bind="attrs" v-on="on"
											dense clearable outlined></v-text-field>
									</template>
									<v-date-picker v-model="query.start"  @input="menu1=false" no-title scrollable locale="zh-cn">
									</v-date-picker>
								</v-menu>
							</div>
							<div style="width: 260px;" class="mr-1">
								<v-menu ref="menu2" v-model="menu2" :close-on-content-click="false"
									 transition="scale-transition" offset-y min-width="auto">
									<template v-slot:activator="{ on, attrs }">
										<v-text-field v-model="query.end" label="结束日期" readonly v-bind="attrs" v-on="on"
											dense clearable outlined></v-text-field>
									</template>
									<v-date-picker v-model="query.end" @input="menu2=false" no-title scrollable locale="zh-cn">
									</v-date-picker>
								</v-menu>
							</div>
							<v-btn @click="getTableDataList" color="primary">查询</v-btn>
						</v-col>
					</v-row>
					<v-divider></v-divider>
				</template>
			
				
			</v-data-table>
			<div class="text-left pt-2">
				<v-row dense align="center">
					<v-col cols="1" >
						<v-select :items="[10, 20, 50, 100]" @change="handleSizeChange" dense hide-details label="每页数量"
							outlined v-model="query.size" />
					</v-col>
					<v-col cols="1">
						<span>共{{data.total}}项</span>
					</v-col>
					<v-col cols="3">
						<span>本页统计：</span>
						<span>合计消课时数{{sumTotalReduceHours}},</span>
						<span>合计消学费金额{{sumTotalReduceTuitionFee}},</span>
						<span>合计消课收入{{sumTotalRevenueAmount}}</span>
						
					</v-col>
					<v-col cols="7"   v-if="Math.ceil(data.total/query.size)>0">
						<v-pagination :length="Math.ceil(data.total/query.size)" @input="handleCurrentChange"
							total-visible="10" v-model="query.page" />
					</v-col>
				</v-row>
			</div>
		</v-card-text>

	</v-card>
</template>

<script>
	import utils from "../../../config/utils"

	export default {
		name: "day-class-revenue-list",
		data() {
			return {
				menu1: false, // 开始时间菜单
				menu2: false, // 结束时间菜单
				breadcrumbs: [{
						text: '首页',
						disabled: false,
						href: "/"
					},
					{
						text: '数据报表',
						disabled: true
					},
					{
						text: '日消课收入统计',
						disabled: true
					},
				],
				shopId:"",
				data: {
					total: 0,
					headers: [
						{
							text: '校区',
							value: 'shopName',
							sortable: false
						},
						{
							text: '日期',
							value: 'bizDate',
							sortable: false
						},
						{
							text: '扣课时数',
							value: 'reduceClassHours',
							sortable: false
						},
						{
							text: '扣学费金额',
							value: 'reduceTuitionFee',
							sortable: false
						},
						{
							text: '消课收入',
							value: 'recordRevenueAmount',
							sortable: false
						},
					],
					list: [],
				},
				query: {
					loading: false,
					page: 1,
					size: 20,
					start: "",
					end: "",
				},
			}
		},
		created() {
			this.shopId = utils.getCurrentShopId();
			this.getTableDataList();
		},
		computed:{
			// 总缴费汇总
			sumTotalRevenueAmount(){
				let result = 0;
				if(this.data.list){
					this.data.list.forEach((item,index)=>{
						result = result+ parseFloat(item.recordRevenueAmount);
					})
				}
				return result.toFixed(2);
			},
			sumTotalReduceHours(){
				let result = 0;
				if(this.data.list){
					this.data.list.forEach((item,index)=>{
						result = result+ parseInt(item.reduceClassHours);
					})
				}
				return result;
			},
			sumTotalReduceTuitionFee(){
				let result = 0;
				if(this.data.list){
					this.data.list.forEach((item,index)=>{
						result = result+ parseInt(item.reduceTuitionFee);
					})
				}
				return result;
			}
			
		},
		methods: {
			handleSizeChange(size) {
				this.query.size = size;
				this.query.page = 1;
				this.getTableDataList();
			},
			handleCurrentChange(page) {
				this.query.page = page;
				this.getTableDataList();
			},
			
			getTableDataList() {
				const that = this;
				this.query.loading = true;


				let url = `/report/day/class/revenue/list/page/${that.query.page - 1}/size/${that.query.size}?v=1`;
				if (this.query.start) {
					url += "&start=" + this.query.start;
				}
				if (this.query.end) {
					url += "&end=" + this.query.end;
				}
				if (this.shopId) {
					url += "&shopId=" + this.shopId;
				}
				
				
				this.axios.get(url).catch(()=>{
					console.log("=============api catch=============");
					return;
				}).then(response => {
					that.query.loading = false;
					
					if (!response){
						that.$noty.error("获取数据失败")
						return;
					}
				
					if (response.data["code"] === 200) {
						that.data.list = response.data["data"]["list"] ? response.data["data"]["list"] : [];
						that.data.total = response.data["data"]["count"];
						return
					}
				
					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},
		}
	}
</script>

<style>
</style>
